import { AxiosPromise } from 'axios';
import { IGetStudentClasses } from '../models/studentsClass.model';
import axios from 'axios';

const uri = '/mgmt/students/class';

export const getStudentClasses = (studentCode: string): AxiosPromise<IGetStudentClasses> => {
  return axios.get(`${uri}/${studentCode}`);
}
